var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmployees = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6923 1C17.794 1 18.8505 1.43764 19.6295 2.21663C20.4085 2.99563 20.8462 4.05218 20.8462 5.15385C20.8462 6.25551 20.4085 7.31206 19.6295 8.09106C18.8505 8.87006 17.794 9.30769 16.6923 9.30769M19.6462 13.3508C21.2188 13.949 22.5727 15.0107 23.5287 16.3952C24.4847 17.7798 24.9978 19.4221 25 21.1046V23.1538H22.2308M13.4615 5.15385C13.4615 7.44795 11.6018 9.30769 9.30769 9.30769C7.01359 9.30769 5.15385 7.44795 5.15385 5.15385C5.15385 2.85974 7.01359 1 9.30769 1C11.6018 1 13.4615 2.85974 13.4615 5.15385ZM17.6154 23.1538H1V21.3077C1 19.1044 1.87527 16.9913 3.43327 15.4333C4.99126 13.8753 7.10436 13 9.30769 13C11.511 13 13.6241 13.8753 15.1821 15.4333C16.7401 16.9913 17.6154 19.1044 17.6154 21.3077V23.1538Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmployees);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/employees.60ba3a46d38a184af15cbe0970e9a724.svg";